module.exports = __webpack_public_path__ + "img/Light.2f9fb477.png";